/* eslint-disable max-len */
import React, { FC } from 'react'

interface FinancialCalcReversalCalcButtonProps {
  isPending: boolean
  isResponsive: boolean
}

export const FinancialCalcReversalCalcButton: FC<FinancialCalcReversalCalcButtonProps> = React.memo(
  ({ isPending, isResponsive }) => {
    return (
      <div className="u-text--center u-mt40px">
        <button className="c-button-calc" type="submit" disabled={isPending} id="btn_reversal">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164 92">
            <defs>
              <filter id="a" x="0" y="0" width="164" height="92" filterUnits="userSpaceOnUse">
                <feOffset dx="4" dy="4" />
                <feGaussianBlur result="blur" />
                <feFlood floodColor="#5a435a" />
                <feComposite operator="in" in2="blur" />
                <feComposite in="SourceGraphic" />
              </filter>
            </defs>
            <g filter="url(#a)">
              <g fill="#fff" className="c-button-calc__bg">
                <path d="M80 85.854L1.998 55.63V10.001c0-4.411 3.59-8 8.002-8h140.002c4.412 0 8 3.589 8 8V55.63L80 85.854z" />
                <path
                  d="M80 83.709l76.002-29.449V10.001c0-3.308-2.691-6-6-6H10a6.008 6.008 0 00-6.002 6V54.26L80 83.71m0 4.29L-.002 57V10.001c0-5.524 4.477-10 10.002-10h140.002c5.52 0 10 4.476 10 10V57L80 87.998z"
                  fill="#62a598"
                />
              </g>
            </g>
          </svg>
          <span>計算する</span>
        </button>
      </div>
    )
  }
)
